"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion, useReducedMotion } from "framer-motion";
import GradientButton from "@/components/ui/GradientButton";
import { FaChevronRight } from "react-icons/fa";
const HERO_PHOTO = "/images/brokerage/broker-order.png";
export default function HeroSection() {
  const $ = _c(40);
  const desktopAnimations = useDesktopAnimations();
  useReducedMotion();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 50
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="text-[#1877e6] dark:text-[#3b82f6]">Brokerage Order</span>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t0 || $[10] !== t1 || $[11] !== t2) {
    t6 = <motion.h1 initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="font-poppins mb-7 max-w-[620px] text-[32px] font-bold leading-[1.3] tracking-tight text-[#0b1354] sm:text-[40px] lg:text-[56px] dark:text-white">Quickly Build a Powerful {t5}{" "}Management App</motion.h1>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== desktopAnimations) {
    t7 = desktopAnimations ? {
      opacity: 0,
      y: 30
    } : false;
    $[13] = desktopAnimations;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== desktopAnimations) {
    t8 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[15] = desktopAnimations;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== desktopAnimations) {
    t9 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[17] = desktopAnimations;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      duration: 0.6,
      delay: 0.15
    };
    t11 = {
      once: true
    };
    $[19] = t10;
    $[20] = t11;
  } else {
    t10 = $[19];
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t12 = <motion.p initial={t7} whileInView={t8} animate={t9} transition={t10} viewport={t11} className="mb-9 max-w-[615px] text-[16px] leading-[30px] text-[#6b7280] lg:text-[17px] dark:text-gray-400">Our order management process has been completely transformed! The system is incredibly fast, user-friendly, and helps us save hours of valuable time every day. It's an essential tool for any growing business looking to improve efficiency and stay organized!</motion.p>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <GradientButton href="/contact" variant="peach-pink">Get a Free Consultation <FaChevronRight className="ml-1 text-[12px]" /></GradientButton>;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t6) {
    t14 = <div className="z-10 flex flex-col items-start text-left">{t6}{t12}{t13}</div>;
    $[26] = t12;
    $[27] = t6;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== desktopAnimations) {
    t15 = desktopAnimations ? {
      y: [0, -15, 0]
    } : undefined;
    $[29] = desktopAnimations;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== desktopAnimations) {
    t16 = desktopAnimations ? {
      duration: 4,
      repeat: Infinity,
      ease: "easeInOut"
    } : undefined;
    $[31] = desktopAnimations;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Image src={HERO_PHOTO} alt="Managing brokerage orders with The Dezine order management app" width={600} height={500} className="h-auto w-full object-contain transition-transform duration-300 hover:scale-[1.03]" />;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t15 || $[35] !== t16) {
    t18 = <motion.div animate={t15} transition={t16} className="relative z-10 mx-auto w-full max-w-[600px]">{t17}</motion.div>;
    $[34] = t15;
    $[35] = t16;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t14 || $[38] !== t18) {
    t19 = <section className="relative overflow-hidden bg-[linear-gradient(180deg,#e6f2fd_0%,#f1f8fe_45%,#ffffff_100%)] pt-12 font-sans sm:pt-16 lg:pt-24 dark:bg-gray-950 dark:bg-none"><div className="mx-auto grid w-full max-w-[1290px] grid-cols-1 items-center gap-14 px-[15px] pb-16 md:pb-24 lg:grid-cols-2 lg:gap-12">{t14}{t18}</div></section>;
    $[37] = t14;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  return t19;
}